interface LogoMarkProps {
  /** Pixel size — matches sidebar (md), mobile header (sm), and auth page (lg) contexts. */
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZE_MAP = {
  sm: 32,
  md: 40,
  lg: 48,
} as const

/** The LogMySpends brand mark: an open ledger with a logged entry. */
export function LogoMark({ size = 'md', className = '' }: LogoMarkProps) {
  const px = SIZE_MAP[size]
  return (
    <img
      src="/logo-mark.png"
      alt="LogMySpends"
      width={px}
      height={px}
      className={`rounded-xl shrink-0 ${className}`}
      style={{ width: px, height: px }}
    />
  )
}
